export enum ESuccessType {
  TRACK = 'track',
  PHOTOS = 'photos',
  WAYPOINT = 'waypoint',
}

export enum EPopoverPhotoType {
  PHOTOS = 'photos',
  LIBRARY = 'library',
}
